import { Link } from 'react-router-dom'

/** Κοινό υποσέλιδο με σύνδεσμο διαχείρισης. */
export function AppFooter() {
  return (
    <footer
      className="mt-auto border-t border-zinc-200/90 bg-white/60 py-1.5 backdrop-blur-sm dark:border-zinc-800/90 dark:bg-zinc-950/60"
      role="contentinfo"
    >
      <div className="mx-auto flex w-full max-w-6xl flex-wrap items-center justify-between gap-x-4 gap-y-1 px-4 text-xs sm:px-6">
        <p className="min-w-0 truncate text-[11px] text-zinc-500 dark:text-zinc-400">
          <span className="font-semibold text-zinc-600 dark:text-zinc-300">ProfferAI</span>
          <span className="hidden text-zinc-400 sm:inline dark:text-zinc-500">
            {' '}
            · προσφορές για επαγγελματίες
          </span>
        </p>
        <div className="flex shrink-0 flex-wrap items-center gap-x-3 gap-y-0.5">
          <Link
            to="/terms"
            className="text-[11px] font-medium text-zinc-500 underline-offset-2 transition hover:text-zinc-800 hover:underline dark:text-zinc-500 dark:hover:text-zinc-300"
          >
            Όροι
          </Link>
          <Link
            to="/privacy"
            className="text-[11px] font-medium text-zinc-500 underline-offset-2 transition hover:text-zinc-800 hover:underline dark:text-zinc-500 dark:hover:text-zinc-300"
          >
            Απόρρητο
          </Link>
          <Link
            to="/admin/login"
            className="text-[11px] font-medium text-zinc-500 underline-offset-2 transition hover:text-zinc-800 hover:underline dark:text-zinc-500 dark:hover:text-zinc-300"
          >
            Διαχείριση
          </Link>
        </div>
      </div>
    </footer>
  )
}
